import React from 'react'

function Loading() {
  return <div style={{ paddingTop: 30, paddingLeft: 10 }}> Loading... </div>
}

export default Loading
